import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccEntertainmentIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccEntertainmentIcon(props: MccEntertainmentIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('MccEntertainmentIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Entertainment')}
      {...rest}
    >
      <path
        d="M7.99998 14.6666C11.6819 14.6666 14.6666 11.6818 14.6666 7.99992C14.6666 4.31802 11.6819 1.33325 7.99998 1.33325C4.31808 1.33325 1.33331 4.31802 1.33331 7.99992C1.33331 11.6818 4.31808 14.6666 7.99998 14.6666Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33331 5.97681C6.33331 5.65862 6.33331 5.49952 6.39981 5.4107C6.45775 5.3333 6.54646 5.28488 6.6429 5.27799C6.75357 5.27008 6.8874 5.35611 7.15505 5.52818L10.3021 7.55129C10.5344 7.7006 10.6505 7.77525 10.6906 7.87018C10.7257 7.95312 10.7257 8.04672 10.6906 8.12966C10.6505 8.22459 10.5344 8.29924 10.3021 8.44855L7.15505 10.4717C6.8874 10.6437 6.75357 10.7298 6.6429 10.7219C6.54646 10.715 6.45775 10.6665 6.39981 10.5891C6.33331 10.5003 6.33331 10.3412 6.33331 10.023V5.97681Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
